/**
 * Copyright(c) Live2D Inc. All rights reserved.
 *
 * Use of this source code is governed by the Live2D Open Software license
 * that can be found at https://www.live2d.com/eula/live2d-open-software-license-agreement_en.html.
 */

import { LAppDelegate } from './lappdelegate';
import { Live2dWebSDK } from '../lib/live2dWebSDK';

export async function loadv2(canvasId, options, manifest = null) {
  const token = options.userInfo;
  if (token && token.sign) {
    if (await Live2dWebSDK.VerifySignAPI(token)) {
      options.headPos = typeof options.headPos === 'undefined' ? 0.5 : options.headPos;
      if (!LAppDelegate.getInstance().initialize(canvasId, options.modelAPI, options, manifest)) {
        return;
      }
      LAppDelegate.getInstance().run();
    }
    else {
      console.warn("V3模型需要付费才可加载.");
    }
  } else {
    console.warn("需要与插件官网链接后才可以使用, 请先登录, 或访问https://www.live2dweb.com/ 了解更多");
  }
}
export function screenshotV2(captureName, captureFrame) {
  LAppDelegate.getInstance()._captureFrame = captureFrame;
  LAppDelegate.getInstance()._captureName = captureName;
}
/**
 * 終了時の処理
 */
window.onbeforeunload = () => LAppDelegate.releaseInstance();
window.loadv2 = loadv2;

/**
 * Process when changing screen size.
 */
/*window.onresize = () => {
  if (LAppDefine.CanvasSize === 'auto') {
    LAppDelegate.getInstance().onResize();
  }
};
*/